module.exports = __webpack_public_path__ + "static/img/cs-title-example.5401cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/device/cs-title-example.png
// module id = 7ZdJ
// module chunks = 1